import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { AppRoute } from '../routes.types';

const FreemiumReportView = lazy(() => import('../../containers/Reports/ViewReport/Freemium/latest-index'));
const FreemiumReport = lazy(() => import('../../containers/Reports/Freemium/Freemium'));
const PaidEvaluation = lazy(() => import('../../containers/Reports/PaidEvaluation/PaidEvaluation'));
const ApvarReportInput = lazy(() => import('../../containers/Reports/ApvarReport/ApvarReportInput'));
const PaidEvaluationReport = lazy(() => import('../../containers/Reports/ViewReport/PaidEvaluationReport'));
const DetailedReports = lazy(() => import('../../containers/DetailedReports/DetailedReports'));

export const REPORT_ROUTES: AppRoute[] = [
    {
        path: '/report',
        element: <Outlet />,
        withAppShell: true,
        children: [
            { path: 'free', element: <FreemiumReport /> },
            { path: 'evaluation', element: <PaidEvaluation /> },
            { path: 'apvarinput', element: <ApvarReportInput /> },
        ],
    },
    { path: '/view/freemium/:id', element: <FreemiumReportView />, withAppShell: true },
    { path: '/view/paidevaluation/:id', element: <PaidEvaluationReport />, withAppShell: true },
    { path: '/detailedreports', element: <DetailedReports /> },
];
